import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { voiceActionTypeLabel } from '../../helpers/voiceActionDisplay';
import type { VoiceActionTypeValue } from '../../types/voice';

interface ActionCardTypeLabelProps {
  type: VoiceActionTypeValue;
}

export const ActionCardTypeLabel: FC<ActionCardTypeLabelProps> = ({ type }) => (
  <Text
    style={{
      fontSize: 10,
      color: 'var(--tg-theme-hint-color)',
    }}
  >
    {voiceActionTypeLabel(type)}
  </Text>
);
